<aipb-ol-map
  (mapReady)="onMapReady($event)"
  [controls]="controls$ | async"
  [interactions]="interactions$ | async"
  [layers]="layers$ | async"
  [overlays]="overlays$ | async"
  [view]="view$ | async"
  class="h-full"
>
  @if (items.length > 0) {
    <div ol-map-left-sidebar>
      <div class="flex flex-col justify-center items-center p-2 h-full">
        <button (click)="onPrev()" [disabled]="isPrevDisabled()" class="bg-white" mat-icon-button>
          <mat-icon class="text-secondary">chevron_left</mat-icon>
        </button>
      </div>
    </div>
  }

  @if (items.length > 0) {
    <div ol-map-right-sidebar>
      <div class="flex flex-col justify-center items-center p-2 h-full">
        <button (click)="onNext()" [disabled]="isNextDisabled()" class="bg-white" mat-icon-button>
          <mat-icon class="text-secondary">chevron_right</mat-icon>
        </button>
      </div>
    </div>
  }
</aipb-ol-map>
